'use client';

import { Children, cloneElement, createContext, useContext } from 'react';

import type { FC, ReactElement } from 'react';

export interface ProviderProps<T = Record<string, unknown>> {
  children?: ReactElement;
  data?: T;
}

const Context = createContext<Record<string, unknown>>( {} );

export const useProvider = (): Record<string, unknown> =>
  useContext<Record<string, unknown>>( Context );

/**
 * Provides a Context for the Data Prop
 */
export const Provider: FC<ProviderProps> = ({
  children,
  data = {},
  ...props
}) => (children
  ? (
    <Context.Provider value={data}>
      {Children.map( children, (child, index) => cloneElement( child, { key: index, ...props } ) )}
    </Context.Provider>
  )
  : null);
